/* filepath: /Users/george/MatrizInc/MarketBrewer/Clients/street-lawyer-services/website/src/core/Pages/ProductsPage/index.tsx */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import ProductsHero from "./ProductsHero";
import ProductCategories from "./ProductCategories";
import FeaturedProductsGrid from "./FeaturedProductsGrid";
import ProductBenefits from "./ProductBenefits";
import TestimonialsSlider from "./TestimonialsSlider";
import { META, generateProductsRichSnippet } from "./meta";

const ProductsPage: React.FC = () => {
  const richSnippet = generateProductsRichSnippet();

  // Add class to body when component mounts and remove it when unmounts
  useEffect(() => {
    document.body.classList.add("has-hero-section");
    return () => {
      document.body.classList.remove("has-hero-section");
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>{META.title}</title>
        <meta name="description" content={META.meta_description} />
        <meta name="keywords" content={META.keywords} />
        <link
          rel="canonical"
          href={`https://slsdispensary.com${META.canonicalUrl}`}
        />

        {/* OpenGraph Meta Tags */}
        <meta property="og:title" content={META.title} />
        <meta property="og:description" content={META.meta_description} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://slsdispensary.com${META.canonicalUrl}`}
        />
        <meta
          property="og:image"
          content="https://slsdispensary.com/images/weed-jar-and-street-lawyer-services-logo.jpg"
        />
        <meta property="og:site_name" content="Street Lawyer Services" />

        {/* JSON-LD for rich snippets */}
        <script type="application/ld+json">
          {JSON.stringify(richSnippet)}
        </script>
      </Helmet>

      <ProductsHero />
      <ProductCategories />
      <FeaturedProductsGrid />
      <ProductBenefits />
      <TestimonialsSlider />
    </>
  );
};

export default ProductsPage;
